import { render } from "./IdeaQuiz.vue?vue&type=template&id=9a1c1542&scoped=true"
import script from "./IdeaQuiz.vue?vue&type=script&lang=js"
export * from "./IdeaQuiz.vue?vue&type=script&lang=js"

import "./IdeaQuiz.vue?vue&type=style&index=0&id=9a1c1542&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1c1542"]])

export default __exports__